var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9024 0H3.10125C1.38959 0 0.00195312 1.32183 0.00195312 2.95245V18.9577C0.00195312 20.5883 1.38953 21.9101 3.10125 21.9101H11.3875L11.4016 14.0806H9.26636C8.98887 14.0806 8.76365 13.8669 8.76258 13.6025L8.75234 11.0788C8.75127 10.813 8.97717 10.597 9.25618 10.597H11.3876V8.15837C11.3876 5.32839 13.2019 3.78745 15.852 3.78745H18.0266C18.3048 3.78745 18.5304 4.00233 18.5304 4.26742V6.39548C18.5304 6.66046 18.305 6.87529 18.0269 6.87545L16.6924 6.87604C15.2512 6.87604 14.9721 7.52843 14.9721 8.48585V10.597H18.1389C18.4406 10.597 18.6748 10.848 18.6392 11.1335L18.3252 13.6573C18.2951 13.8988 18.0802 14.0807 17.8249 14.0807H14.9862L14.9721 21.9102H19.9025C21.6142 21.9102 23.0018 20.5884 23.0018 18.9578V2.95245C23.0017 1.32183 21.6141 0 19.9024 0Z",
    fill: "#9B9999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.064ab828.svg";
export { ForwardRef as ReactComponent };